angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsAgendaPerfPreview', function (
  $log,
  language,
  C4_ASSET_URL,
  GR78_ASSET_URL,
  PanelFactory,
  $timeout,
  api,
  EventManager,
  userAccount,
  preliveCheck,
  TeacherDataService,
  ModuleFilter,
  PlatformService,
  $q
) {
  return {
    templateUrl: 'template.html',
    scope: {
      agendaData: '<',
      studentsList: '<',
      moduleMap: '<',
      filteredView: '=?',
      dontCollapse:'=?',
      viewController:'=?',
      filteredResources: '=?',
      classId: '=?',
      agendaProgressMap: '=?',
      dontSelect: '<',
      unlockPath: '<',
      moduleMapCopy: '=?'
    },
    link: function (scope, element) {
      scope.isAgendaView = TeacherDataService.inTeacherAgendaView;
      scope.getTranslation = function(slug) {
        return language.get(slug)
      }

      scope.isModuleAvailable = (module) => {
        if (module.parent_resource_id !== 192) {
          return ModuleFilter.checkAvailable(module);
        }
        else {
          return false;
        }
      }
      var eventManager = new EventManager('teacherStudentsAgendaPerfPreview', scope);
      scope.isQC = preliveCheck.isQCCheck();
      scope.isPrelive = preliveCheck.isPreliveCheck();
      scope.isTeacher = userAccount.getData().role.isTeacher;
      var target_students;
      var student_count;

      // scope.getName = function(slug){
      //   // var modified = slug.split(':')[1];
      //   // modified = modified ? modified.trim() : slug;
      //   return language.get(slug);
      // }

      scope.getModuleIconAssetUrl = function(item){
        if(scope.moduleMap && scope.moduleMap.meta_config && scope.moduleMap.meta_config.map_config && scope.moduleMap.meta_config.map_config.set_module_icon_names){
          var asset_name = scope.moduleMap.meta_config.map_config.set_module_icon_names[item.slug] || scope.moduleMap.meta_config.map_config.set_module_icon_names.default;
          return scope.moduleMap.meta_config.map_config.asset_url + asset_name + ".png";
        }
        if(item.config.map_config && item.config.map_config.asset_url){
          return item.config.map_config.asset_url+item.slug+'.png';
        }
        return PanelFactory.getModuleIconAssetUrl(item.slug);
      } 

      function displayOrderSort(a,b) {
        if(!a.display || !b.display ){
          return 0;
        }
        if (a.display.order < b.display.order){
            return -1;
        }
        if (a.display.order > b.display.order){
            return 1;
        }
        return 0;
      }

      var loading_items;
      var loaded_preticked;
      function resetView(dontOverwrite, keepSelections){
        if(!scope.moduleMap || loading_items){
          return;
        }
        loading_items = true;
        scope.moduleMap.resources = scope.moduleMap.resources.sort(displayOrderSort);

        scope.asset_url = scope.moduleMap.resources && scope.moduleMap.resources[0].parent_resource_id === 99 ? GR78_ASSET_URL : C4_ASSET_URL;

        scope.inFilteredView = true;
        if(!dontOverwrite){
          if(!scope.moduleMapCopy){
            scope.moduleMapCopy = angular.copy(scope.moduleMap.resources);
          }
          scope.moduleMapCopy.forEach(function(sub_mod){
            sub_mod.show = false;
            sub_mod.transparent = false;
            sub_mod.display.panel.forEach(function(sub_sub){
              reset_shown(sub_sub);
            })
          })
          //scope.moduleMapCopy = angular.copy(scope.moduleMap.resources);
          //scope.moduleMapCopy = applySelections(temp, )
          scope.moduleMapCopy.forEach(function(sub_mod){
            var indx = 0;
            sub_mod.children.forEach(function(item){
              if( _.get(item, ['config', 'exclude']) ){
                sub_mod.children.splice(indx, 1);
                removePanelItem(sub_mod.slug + ': ' + item.slug);
              }
              indx ++;
            })
          })
        }
        scope.moduleMapCopy.forEach(function(sub_mod){
          if(sub_mod.display && sub_mod.display.panel){
            sub_mod.display.panel.forEach(function(sub){
              var sub_info = getPath(sub, sub_mod, dontOverwrite);
              var match = getRegMatch(sub_mod.slug);//!scope.filteredView ? true : (scope.getName(sub_mod.slug).toLowerCase()).match((scope.filteredView).toLowerCase()) &&  (scope.getName(sub_mod.slug).toLowerCase()).match((scope.filteredView).toLowerCase()).length > 0;
              sub_mod.show = sub_mod.show || sub_info.show || (match && !scope.filteredResources);
              sub.show = sub.show || (match && !scope.filteredResources);
            })
          }
        })
        if(scope.viewController && scope.viewController.preticked_items && !loaded_preticked){
          loaded_preticked = true;
          scope.viewController.selectItemsFromId(scope.viewController.preticked_items);
          $timeout(function(){
            eventManager.broadcast('highlight:map:items', scope.viewController.preticked_items);
            loading_items = false;
          }, 250)

        }else{
          loading_items = false;
        }
      }

      eventManager.listen('tick:module', function(e, slug){
        scope.moduleMapCopy.forEach(function(mod){
          if(mod.slug === slug){
            mod.is_selected = true;
            scope.toggleItemSubSelection(mod, true);
          }
        })
      })

      function reset_shown(sub){
        sub.show = false;
        sub.transparent = false;
        if(sub.sub){
          sub.sub.forEach(function(sub_sub){
            reset_shown(sub_sub);
          })
        }
      }

      function removePanelItem(slug, parent){
        var indx = 0;
        if(parent){
          parent.forEach(function(child){
            if(child.sub){
              removePanelItem(slug, child.sub);
            }else if(child.slug === slug){
              parent.splice(indx, 1);
            }
            indx++;
          })
          return;
        }
        scope.moduleMapCopy.forEach(function(sub_mod){
          if(sub_mod.display && sub_mod.display.panel){
            indx = 0;
            sub_mod.display.panel.forEach(function(sub){
              if(sub.sub){
                removePanelItem(slug, sub.sub);
              }else if(sub.slug === slug){
                sub_mod.splice(indx, 1);
              }
              indx++;
            })
          }
        })
      }

      function getPath(sub, parent, resetTransparent){
        if(sub.sub){
          var sub_count = 0;
          sub.sub.forEach(function(sub_sub){
            var sub_info = getPath(sub_sub, sub, resetTransparent)
            sub.show = sub.show || sub_info.show;
          })
        }
        var item_info = {show: sub.show}
        if(!scope.filteredResources){
          var match = getRegMatch(sub.slug);          
          
          sub.show = sub.show || match;
          sub.transparent = !match;

          if(parent.sub && !sub.show && scope.filteredView && scope.filteredView !== ''){
            sub.show = hasVisibleSibling(parent.sub);
            //sub.show;
          }
          if(resetTransparent){
            sub.transparent = false;
          }
          item_info.show = sub.show;
        }else{
          var id = sub.id || getResourceIdFromSlug(sub.slug);
          sub.show = sub.show || scope.filteredResources.indexOf(id) > -1;
          item_info.show = sub.show;
        }
        return item_info;
      }

      function hasVisibleSibling(parent){
        var found = false;
        parent.forEach(function(child){
          found = found || getRegMatch(child.slug)//(scope.getName(child.slug).toLowerCase()).match((scope.filteredView).toLowerCase()) &&  (scope.getName(child.slug).toLowerCase()).match((scope.filteredView).toLowerCase()).length > 0;
        })
        return found;
      }

      function getResourceIdFromSlug(slug){
        // if(slug.indexOf(':') > -1){
        //   slug = slug.split(':')[1].trim();
        // }
        var id;
        for(var i = 0; i < scope.moduleMap.resources.length; i++){
          var sub_mod = scope.moduleMap.resources[i].children;
          for(var j = 0; j < sub_mod.length; j++){
            var resource = sub_mod[j];
            if(resource.children){
              for(var k = 0; k < resource.children.length; k++){
                var sub_resource = resource.children[k];
                if(sub_resource.slug === slug){
                  return sub_resource.id;
                }
              }
            }
            if(resource.slug === slug){
              return resource.id;
            }
          }
        }
        return false;
      }

      function getItemSlugFromId(resource_id){
        var found_slug;
        scope.moduleMap.resources.forEach(function(sub_mod){
          sub_mod.children.forEach(function(resource){
            if(resource && resource.id === resource_id){
              found_slug = resource.slug;
            }
          })
        })
        return found_slug;
      }

      scope.$watch('agendaData', function(){
        resetView();
      })
      scope.$watch('studentsList',function(){
        resetView();
      })
      scope.$watch('moduleMap',function(){
        resetView();
      })

      scope.$watch('filteredView',function(new_val, old_val){
        if(old_val && old_val !== '' && new_val === ''){
          resetView(true, true);
          return;
        }
        resetView(false, true);
      })

      scope.$watch('filteredResources', function(val){
        resetView();
      })

      var last_selected;
      scope.$watch('unlockPath', function(val){
        if(val === false){
          eventManager.broadcast('highlight:path', {slug:'', clear: true});
        }else if(val && last_selected && last_selected.is_selected){
          eventManager.broadcast('highlight:path', {slug:last_selected.slug, clear: false});
        }
      })

      scope.selectItem = function(item, select, dontSelect, triggerSelection){
        if(!item.sub && scope.inFilteredView && scope.viewController){
          scope.viewController.highlightedItem = item;
          item.is_selected = triggerSelection ? !item.is_selected : item.is_selected;
          item.show = true;
          last_selected = item.is_selected ? item : '';
          if(scope.unlockPath){
            eventManager.broadcast('highlight:path', {slug:item.slug, clear: false});
          }
          if(dontSelect){
            return;
          }
          $timeout(()=>{
            eventManager.broadcast('module:select:resource', {slug:item.slug, dontSelect: true, state: item.is_selected})
          },500);
        }else if(item.sub){
          // $log.log('parent click : ' , item)
          item.is_selected = !item.is_selected;
        }
      }

      var cached_items = [];
      if(scope.viewController){
        scope.viewController.selectItemBySlug = function(slug, select, dontSelect, triggerSelection){
          scope.moduleMapCopy.forEach(function(sub_mod){
            if(sub_mod.display && sub_mod.display.panel){
              findAndHighlight(sub_mod.display.panel, slug, select, dontSelect, triggerSelection);
            }
          })
        }
        scope.viewController.getSelectedItems = function(){
          var selected = [];
          scope.moduleMapCopy.forEach(function(sub_mod){
            if(sub_mod.display && sub_mod.display.panel){
              if(Array.isArray(sub_mod.display.panel)){
                var i = 0;
                sub_mod.display.panel.forEach(function(child){
                  getSelected(child, selected, sub_mod.slug, i);
                  i++;
                })
              }
            }
          })
          // $log.log('GET SELECTED ITEMS : ', scope.moduleMapCopy)
          return selected;
        }
        eventManager.listen('agenda:request:selected', function(){
          eventManager.broadcast('agenda:respond:selected', scope.viewController.getSelectedItems())
        })
        scope.viewController.selectItemsFromId = function(item_arr){
          // $log.log('got resources : ' , scope.viewController.cached_items, item_arr)
          if(scope.viewController.cached_items && scope.viewController.cached_items.length > 0){
            //item_arr = scope.viewController.cached_items;
            scope.viewController.cached_items.forEach(function(item){
              if(item.type === 'custom_resource'){
                item.content.position_data = {
                  parent_slug: item.parent_slug,
                  index: item.item_index
                }            
                placeCustomInMap(item);
              }
            })
          }
          var custom_arr = []
          item_arr.forEach(function(item_id){
            var slug = getItemSlugFromId(item_id);
            if(slug){
              // $log.log('tick this : ', slug, item_id);
              scope.viewController.selectItemBySlug(slug, true, false, true);
            }else if(scope.classId && typeof item_id === 'number'){
              var resource;
              
              custom_arr.push(api.getCustomResource(scope.classId, item_id))
              // .then(function(resources) {
              //   // $log.log('custom resources : ', resources)
              //   if(resources){
              //     custom_arr.push(resources[0])
              //     // placeCustomInMap(resources[0]);
              //   }
              // })
            }
          })
          $q.all(custom_arr).then(function(results){
            var custom_resources_map = {}
            results.forEach(function(resources){
              if(resources){
                if(!custom_resources_map[resources[0].content.position_data.parent_slug]){
                  custom_resources_map[resources[0].content.position_data.parent_slug] = [];                  
                }
                custom_resources_map[resources[0].content.position_data.parent_slug].push(resources[0]);                
              }
            })
            for(var key in custom_resources_map){
              if(custom_resources_map[key]){
                custom_resources_map[key].sort(sorter)
              }
            }
            for(var el in custom_resources_map){
              if(custom_resources_map[el]){
                placeAllInMap(custom_resources_map[el]);
              }
            }
            $log.log('sorted : ' , custom_resources_map);
          })
        }
      }

      function placeAllInMap(list){
        list.forEach(function(resource){
          placeCustomInMap(resource);
        })
      }

      function sorter(a,b){
        var indx1 = Number(a.content.position_data.index);
        var indx2 = Number(b.content.position_data.index);
        if (indx1 < indx2){
          return -1;
        }
        if (indx1 > indx2){
            return 1;
        }
        return 0;
      }

      var placeCustomInMap = function(resource){
        
        var parent_slug = resource.content.position_data.parent_slug;
        var index = Number(resource.content.position_data.index);
        if(parent_slug === scope.moduleMap.slug){
          scope.moduleMapCopy.splice(index , 0 , resource)
          return;
        }
        $log.log('place custom :  ', parent_slug, index, scope.moduleMap.slug)
        scope.moduleMapCopy.forEach(function(sub_mod){
          if(sub_mod.display && sub_mod.display.panel){
            if(sub_mod.slug === parent_slug){
              sub_mod.display.panel.splice(index, 0, resource);
              resource.show = true;
              resource.is_selected = true;
              return;
            }else{
              sub_mod.display.panel.forEach(function(sub){
                checkResourceAndInsert(sub, resource);
              })
            }            
          }
        })
      }
      var checkResourceAndInsert = function(sub, resource){
        if(sub.sub){
          if(sub.slug === resource.content.position_data.parent_slug && (sub.sub.length <= Number(resource.content.position_data.index) || sub.sub[Number(resource.content.position_data.index)].slug !== resource.slug)){
            sub.sub.splice(Number(resource.content.position_data.index) , 0 , resource);
            resource.show = true;
            resource.is_selected = true;
          }else{
            sub.sub.forEach(function(sub_sub){
              checkResourceAndInsert(sub_sub, resource);
            })
          }
        }
      }
      function findAndHighlight(sub, slug, select, dontSelect, triggerSelection){
        if(sub.slug === slug){
          scope.selectItem(sub, select, dontSelect, triggerSelection);
        }else if(sub.sub){
          sub.sub.forEach(function(sub_child){
            findAndHighlight(sub_child, slug, select, dontSelect, triggerSelection);
          })
        }else if(Array.isArray(sub)){
          sub.forEach(function(sub_child){
            findAndHighlight(sub_child, slug, select, dontSelect, triggerSelection);
          })
        }
      }

      function getSelected(sub, arr, parent, index){
        if(!sub.sub && sub.is_selected){
          sub.parent_slug = parent;
          sub.item_index = index;
          arr.push(sub)
        }else if(sub.sub){
          var i = 0;
          sub.sub.forEach(function(sub_child){
            getSelected(sub_child, arr, sub.slug, i);
            i++
          })
        }
      }

      scope.selectParent = function(item){
        item.is_selected = !item.is_selected;
      }

      scope.toggleItemSubSelection = function(item, parent_selection){        
        if(scope.viewController.isStudentView){
          return;
        }        
        if(item.sub){
          item.sub.forEach(function(child){
            if(child.sub){
              child.is_selected = item.is_selected;
            }
            scope.toggleItemSubSelection(child, item.is_selected);
          })
          eventManager.broadcast('highlight:path', {slug:'', clear: true});
        }else if(item.display && item.display.panel){
          item.display.panel.forEach(function(child){
            if(child.sub){
              child.is_selected = item.is_selected;
            }
            scope.toggleItemSubSelection(child, item.is_selected);
          })
        }else{
          if(parent_selection || parent_selection === false){
            if(parent_selection === item.is_selected || (!parent_selection && !item.is_selected)){
              return;
            }
            item.is_selected = parent_selection;
          }
          eventManager.broadcast('module:select:resource', {slug:item.slug, dontSelect: true, state: item.is_selected})
        }        
      }

      function getItemFromSlug(slug){
        // if(slug.indexOf('run_like_math') > -1){
        //   slug = 'run_like_math';
        // }
        for(var i =0 ;i < scope.moduleMap.resources.length; i++){
          if(scope.moduleMap.resources[i].slug === slug){
            return scope.moduleMap.resources[i];
          }
          for(var j =0 ;j < scope.moduleMap.resources[i].children.length; j++){
            var item = scope.moduleMap.resources[i].children[j];
            if(item.slug === slug){
              return item;
            }
          }
        }
      }

      scope.selectChildItem = function(item){
        if(item.sub || scope.dontSelect){
          return;
        }
        if(scope.viewController.highlightedItem){
          eventManager.broadcast('hide_item_selection_highlight', scope.viewController.highlightedItem)
        }
        scope.viewController.highlightedItem = item;
        if(item.resource_type === 'custom_resource'){
          eventManager.broadcast('open:custom:resource', {url:item.content.value, slug:item.slug, id:item.id, name:item.name})
          return;
        }        
        var item_to_broadcast = angular.copy(getItemFromSlug(item.slug));
        item_to_broadcast.dontSelect = true;
        item_to_broadcast.centerOnItem = true;
        item_to_broadcast.highlightItem = true;

        if(!ModuleFilter.checkAvailable(item)){
          item.locked = true;
          item_to_broadcast.locked = true;
          eventManager.broadcast('display-maintenance-message', item.slug);
        }
        eventManager.broadcast('module:select:resource', item_to_broadcast);
        if(!scope.viewController || (scope.viewController && scope.viewController.isStudentView)){
          return;
        }
        last_selected = item.is_selected ? item : '';
        if(scope.unlockPath){
          eventManager.broadcast('highlight:path', {slug:item.slug, clear: !item.is_selected});
        }

      }

      eventManager.listen('module:select:resource', function(e, item){
        if(item && (!item.dontSelect || item.state)){
          scope.moduleMapCopy.forEach(function(sub_mod){
            sub_mod.display.panel.forEach(function(sub){
              if(sub.slug === item.slug){
                sub.show = true
              }else if(sub.sub){
                sub.sub.forEach(function(child){
                  if(child.slug === item.slug){
                    sub_mod.showSubMods = true
                    child.show = true
                    sub.showSubs = true
                    sub.show = true
                  }
                })
              }
            })
          })
        }
      })

      scope.getListItemClass = function(item){
        // $timeout(function(){
          var foundOne = false; var foundNotOne = false;
          var is_partial;
          if(item.display && item.display.panel){
            item.display.panel.forEach(function(sub){
              if(sub.is_selected){
                foundOne = true;
              }else{
                foundNotOne = true;
              }
              is_partial = is_partial === 'mticCheckbox--partialSelection' ? is_partial : scope.getListItemClass(sub);
            })
            if(!foundNotOne){
              item.is_selected = true;
              return is_partial;
            }else if(foundOne){
              item.is_selected = true;
              return 'mticCheckbox--partialSelection';
            }else{
              item.is_selected = false;
              return ''
            }
          }else if(item.sub){
            item.sub.forEach(function(sub){
              if(sub.is_selected){
                foundOne = true;
              }else{
                foundNotOne = true;
              }
              is_partial = is_partial === 'mticCheckbox--partialSelection' ? is_partial : scope.getListItemClass(sub);
            })
            if(!foundNotOne){
              item.is_selected = true;
              return is_partial;
            }else if(foundOne){
              item.is_selected = true;
              return 'mticCheckbox--partialSelection';
            }else{
              item.is_selected = false;
              return ''
            }
          }else{
            return '';
          }
        // }, 200)
      }

      scope.toggleCustomSelection = function(sub){
        sub.is_selected = !sub.is_selected;
      }

      scope.getCheckIconClass = function(item){
        var foundOne = false; var foundNotOne = false;
        var is_partial;
        if(item.sub){
          item.sub.forEach(function(sub){
            var id = getResourceIdFromSlug(sub.slug);
            if(id && scope.filteredResources.indexOf(id) > -1){
              var sub_state = scope.getCheckIconClass(sub);
              if(is_partial === 'fa-adjust' || sub_state === 'fa-adjust' || (is_partial === 'fa-circle-thin' && sub_state === 'fa-check-circle') || (sub_state === 'fa-circle-thin' && is_partial === 'fa-check-circle')){
                is_partial = 'fa-adjust';
              }else{
                is_partial = sub_state;
              }
            }   
          })
          return is_partial;
        }else{
          return scope.agendaProgressMap[item.slug] ? 'fa-check-circle':'fa-circle-thin';
        }
      }


      scope.getName = function(slug){
        if(slug === 'run_like_math' || slug.indexOf('run_like_math') === -1 || slug.indexOf('lv_') === -1){
          return language.get(slug)
        }else{
          var splt = slug.split('_');
          var level = '';
          if(!isNaN(splt[splt.length-1])){
            level = splt[splt.length-1];
          }
          var trans_slug = slug.replace('_'+level, '');
          //run_like_math_obj[trans_slug][language.getCurrentSelectedLanguage()]
          return language.get(trans_slug)+ ' ' + level;
        }
      }

      function getRegMatch(slug){
        var match = true;
        if(scope.filteredView){
          try{
            match = (scope.getName(slug).toLowerCase()).match((scope.filteredView).toLowerCase()) &&  (scope.getName(slug).toLowerCase()).match((scope.filteredView).toLowerCase()).length > 0
          }catch(e){
            match = false;
          }
        }
        return match
      }

      scope.sendLabelClick = function(e, id){
        if(PlatformService.isIos){
          var elm = document.getElementById(id);
          if(elm){
            elm.click();
          }
        }        
      }

      eventManager.listen('refresh-agenda-sidepanel', function(e, data){
        $log.log('side panel refresh!')
        if(scope.agendaProgressMap){
          scope.agendaProgressMap[data.slug] = data;
        }
      })

      resetView();

    }
  }
})
